import React, { useMemo } from 'react'
import PropTypes from 'prop-types';
import { Button, Card, Container } from 'react-bootstrap'
import { useTable } from 'react-table';
import { ButtonGeneric } from '../../../../common/ButtonGeneric';

export const FilterParametersGuide = (props, context) => {

    const filterColumns = useMemo(() => [
        {
            Header: 'Operator',
            accessor: 'operator',
        },
        {
            Header: 'Description',
            accessor: 'description',
        },
        {
            Header: 'Example',
            accessor: 'example',
        }
    ], []);

    const filterRows = useMemo(() => [
        {
          "operator": "=",
          "description": "Debe coincidir exactamente (para atributos de tipo 'String' se aplica búsqueda por 'like' al final del valor",
          "example": "domicilio=Cabildo+323",
        },
        {
          "operator": "=lt:",
          "description": "< Menor que",
          "example": "importe=lt:3533.67",
        },
        {
          "operator": "=lte:",
          "description": "<= Menor o Igual que",
          "example": "edad=lte:33",
        },
        {
          "operator": "=gt:",
          "description": "> Mayor que",
          "example": "importe=gt:3533.67",
        },
        {
          "operator": "=gte:",
          "description": "<= Mayor o Igual que",
          "example": "edad=gte:33",
        },
        {
          "operator": "=!:",
          "description": "distinto a",
          "example": "codigo=!:ALFA",
        },
        {
          "operator": "=or:(p1,p2,pN)",
          "description": "Condicional lógica que retorna verdadero si, al menos, una de las preposiciones son verdaderas",
          "example": "or:(!:ALFA,isnull:)",
        },
        {
          "operator": "=or:(p1,p2,pN)",
          "description": "Condicional lógica que retorna verdadero si, al menos, una de las preposiciones son verdaderas",
          "example": "or:(!:ALFA,isnull:)",
        },
        {
          "operator": "=and:(p1,p2,pN)",
          "description": "Condicional lógica que retorna verdadero si todas las preposiciones son verdaderas",
          "example": "and:(!:ALFA,!:OMICRON,!:ZETA)",
        },
        {
          "operator": "=btw:(p1,p2)",
          "description": "Define un rango de valores",
          "example": "btw:(1234,5678)",
        },
        {
          "operator": "=isnull:",
          "description": "Indica que se desean registros con el atributo en nulo",
          "example": "deleted_at=isnull:",
        },
        {
          "operator": "=!isnull:",
          "description": "Indica que se desean registros para los cuales el atributo NO SEA NULO",
          "example": "deleted_at=!isnull:",
        },
    ], []);
    
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
        columns: filterColumns,
        data: filterRows,
    });

    return (
        <Container fluid className="main-content-container">
            <div className="wiki">
                <div className="wiki__content">
                    <h3>Filter Parameters Guide</h3>
                    <p>Filter Parameters Guide</p>
                    <p>RESTengine tiene permite aplicar modificadores a los atributos utilizados como filtros (query params). Estos modificadores ofrecen un mayor control sobre lo que se desea buscar, para obtener finalmente conjuntos de registros más específicos.</p>

                    <table {...getTableProps()} className="scrollable-div">
                        <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                            ))}
                            </tr>
                        ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                        {rows.map(row => {
                            prepareRow(row)
                            return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>                                
                                })}                                
                                <td>
                                    <i className='material-icons snx-icon-link' onClick={()=> navigator.clipboard.writeText(row.cells[0].value)}>content_copy</i>
                                </td>
                            </tr>
                            )
                        })}
                        </tbody>
                    </table>
                    <br/>
                    <p>Es posible aplicar los operadores 'lt'; 'lte'; 'gt'; 'gte' sobre atributos del tipo 'String'. Se aplica el orden alfanumérico en estos casos, para comparar si una cadena de caracteres está dentro del rango definido por el operador.</p>
                
                    <br/>
                    <Button onClick={e => { }}>&larr; {context.t('TBD')}</Button>
                </div>
            </div>
         </Container>
    )
}

FilterParametersGuide.contextTypes = {
    t: PropTypes.func.isRequired
}
  
export default FilterParametersGuide

                    {/* <ul>
                    <table className='dataTable mb-1 px-1' dir="auto"> 
                        <thead className='dataTable'>
                            <tr>
                            <th>Operador</th>
                            <th>Descripción</th>
                            <th>Ejemplo</th>
                            </tr>
                        </thead>
                        <tbody className='dataTable'>
                            <tr>
                            <td>=</td>
                            <td>Debe coincidir exactamente (para atributos de tipo 'String' se aplica búsqueda por 'like' al final del valor</td>
                            <td>domicilio=Cabildo+323</td>
                            </tr>
                            <tr>
                            <td>=lt:</td>
                            <td>&lt; Menor que</td>
                            <td>importe=lt:3533.67</td>
                            </tr>
                            <tr>
                            <td>=lte:</td>
                            <td>&lt;= Menor o Igual que</td>
                            <td>edad=lte:33</td>
                            </tr>
                            <tr>
                            <td>=gt:</td>
                            <td>&gt; Mayor que</td>
                            <td>importe=gt:3533.67</td>
                            </tr>
                            <tr>
                            <td>=gte:</td>
                            <td>&lt;= Mayor o Igual que</td>
                            <td>edad=gte:33</td>
                            </tr>
                            <tr>
                            <td>=!:</td>
                            <td>distinto a</td>
                            <td>codigo=!:ALFA</td>
                            </tr>
                            <tr>
                            <td>=or:(p1,p2,pN)</td>
                            <td>Condicional lógica que retorna verdadero si, al menos, una de las preposiciones son verdaderas</td>
                            <td>or:(!:ALFA,isnull:)</td>
                            </tr>
                            <tr >
                            <td>=and:(p1,p2,pN)</td>
                            <td>Condicional lógica que retorna verdadero si todas las preposiciones son verdaderas</td>
                            <td>and:(!:ALFA,!:OMICRON,!:ZETA)</td>
                            </tr>
                            <tr>
                            <td>=btw:(p1,p2)</td>
                            <td>Define un rango de valores</td>
                            <td>btw:(1234,5678)</td>
                            </tr>
                            <tr>
                            <td>=isnull:</td>
                            <td>Indica que se desean registros con el atributo en nulo</td>
                            <td>deleted_at=isnull:</td>
                            </tr>
                            <tr>
                            <td>=!isnull:</td>
                            <td>Indica que se desean registros para los cuales el atributo NO SEA NULO</td>
                            <td>deleted_at=!isnull:</td>
                            </tr>
                        </tbody>
                    </table>
                    </ul> */}